import React from "react";
import {
  drShamim,
  drShamimC1,
  drShamimC2,
  drShamimC3,
  drShamimC4,
  drShamimC5,
  drShamimC6,
  drShamimC7,
  drShamimC8,
  leaf,
} from "../../assets";
import { BsBookmarkPlus } from "react-icons/bs";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";

const MainDoctor = () => {
  const [bookingPopup, setBookingPopup] = useState(false);
  const [bookingData, setBookingData] = useState({
    doctor: "DR. SARKER MAHBUB AHMED SHAMIM",
  });

  const closePopup = (e) => {
    e.preventDefault();
    setBookingPopup(false);
    setBookingData({ doctor: "DR. SARKER MAHBUB AHMED SHAMIM" });
  };

  const openPopup = () => {
    setBookingPopup(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(bookingData);

    //post on DB
    fetch("https://laser-treat-server.onrender.com/single-bookings/save", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bookingData),
    });

    toast.success(`Appointment has been booked successfully`, {
      position: "top-center",
      autoClose: 3000,
    });

    setBookingPopup(false);
    setBookingData({ doctor: "DR. SARKER MAHBUB AHMED SHAMIM" });
  };

  const handleInputs = (e) => {
    setBookingData({ ...bookingData, [e.target.name]: e.target.value });
  };

  return (
    <div id="mainDoctor">
      {bookingPopup && (
        <div className="booking-popup">
          <form onSubmit={handleSubmit}>
            <div className="inp-grp">
              <label>Full Name</label>
              <input
                required
                type="text"
                placeholder="Enter full name"
                name="fullName"
                onChange={handleInputs}
              />
            </div>
            <div className="inp-grp">
              <label>Date</label>
              <input required type="date" name="date" onChange={handleInputs} />
            </div>
            <div className="inp-grp">
              <label>Phone</label>
              <input
                required
                type="number"
                placeholder="Enter phone number"
                name="phone"
                onChange={handleInputs}
              />
            </div>
            <div className="inp-grp">
              <label>Email</label>
              <input
                required
                type="email"
                placeholder="Enter email"
                name="userEmail"
                onChange={handleInputs}
              />
            </div>
            <div className="inp-grp">
              <label>Booking Reason</label>
              <textarea
                required
                placeholder="enter message"
                name="message"
                onChange={handleInputs}
              />
            </div>
            <div className="btns">
              <button type="submit">Confirm</button>
              <button onClick={closePopup}>Cancel</button>
            </div>
          </form>
        </div>
      )}
      <div className="highLight">
        <div className="left">
          <img src={drShamim} alt="" />

          <button onClick={openPopup} className="singleBook">
             Book Appointment
          </button>
        </div>
        <div className="right">
          <small>American Board Certified Aesthetic Dermatologist</small>
          <h1>DR. SARKER MAHBUB AHMED SHAMIM</h1>

          <div className="education">
            <p>MBBS, Dip. Derm (Glasgow, UK)</p>
            <p>Diploma in Aesthetic Medicine (USA), MCPS, FCPS (Dermatology)</p>
          </div>
          <div className="specialities">
            <div>
              <img src={leaf} alt="" />
              <h2>Specialities</h2>
            </div>
            <div className="items">
              <p className="exp">20+ Years Experience</p>
              <p>Skin</p>
              <p>Sex</p>
              <p>Anti-Aging</p>
              <p>Hair Transplant</p>
              <p>Cosmetic Surgeon</p>
            </div>
          </div>
          <div className="area">
            <p>
              <span>Chief Consultant</span> of Laser Treat & Dhaka Dermatology
              Institute
            </p>
            <p>
              <span>Hair Transplant Surgeon</span> of Direct Hair Implantation
            </p>
            <p>
              <span>Vice President</span> of SAARC Association of Aesthetic
              Dermatology (SAARC AAD) Institute
            </p>
            <p>
              <span>Secretary General</span> of Aesthetic Dermatology Society of
              Bangladesh (ADSB) Institute
            </p>
            <p>
              <span>Country Representative</span> of South Asian Alliance
              against Resistant Cutaneous Mycosis (SAARCUM)
            </p>
          </div>
        </div>
      </div>
      <div className="fullDesc">
        <div className="left">
          <p>
            Dr. Sarker Mahbub Ahmed Shamim is a renowned dermatologist & the
            face of Bangladesh in international dermatological fraternity,
            currently he is working as an Associate Professor of Dermatology in
            MH Samorita Medical College & Hospital & Chief Consultant in Dhaka
            Dermatology Institute (DDI), Laser Treat.
          </p>
          <p>
            After completion of MBBS from Institute of Applied Sciences,
            Chittagong in 1999, Dr Shamim completed his post-graduation (MCPS &
            FCPS) in Dermatology in 2009 & 2014 from Bangladesh College of
            Physicians and Surgeons (BCPS). In 2014, he obtained Diploma in
            Dermatology (Dip Derm) from Royal College of Physicians and Surgeons
            of Glasgow. He is also a Board Certified Aesthetic Dermatologist of
            American Academy of Aesthetic Medicine.
          </p>
          <p>
            He is the Vice President of SAARC Association of Aesthetic
            Dermatology (SAARC AAD) & Secretary General of Aesthetic Dermatology
            Society of Bangladesh. He is regarded as the pioneer aesthetic
            dermatologist in Bangladesh & is considered as an international
            faculty on aesthetic dermatology & delivers talk in various
            conferences throughout the world. He is also a popular media
            personality of Bangladesh who delivers speeches on dermatological
            and aesthetics in regular basis.
          </p>
          <p>
            Award winning aesthetic dermatologist Dr. Sarker Mahbub Ahmed Shamim
            has been exercising these practices for a long period of time and
            gained great clinical muscles. He is known as one of the most
            dynamic and experienced BOTOX & Filler expert in the world.
            Performed more than 7000 Filler procedures. Can make you 5-10 years
            younger within 60 minutes. He actually can turn back the clock for
            you.
          </p>
        </div>
        <div className="right">
          <div className="title">
            <img src={leaf} alt="" />
            <h2>ADVANCE TRANING IN</h2>
          </div>
          <div className="trainings">
            <div className="item">
              <p className="bold">MD Codes</p>
              <p>Allergan Medical Institute</p>
            </div>
            <div className="item">
              <p className="bold">Body Shaping</p>
              <p>USA, Germany, Italy & UAE</p>
            </div>
            <div className="item">
              <p className="bold">Botox, Filler & Mesotherapy</p>
              <p>USA, Italy, Singapore & UAE</p>
            </div>
            <div className="item">
              <p className="bold">Hair Transplant</p>
              <p>USA</p>
            </div>
            <div className="item">
              <p className="bold">Whitening & Mesotherapy</p>
              <p>Spain</p>
            </div>
            <div className="item">
              <p className="bold">Cosmetic Surgery</p>
              <p>USA, UAE & Thailand</p>
            </div>
            <div className="item">
              <p className="bold">Sclerotherapy</p>
              <p>USA</p>
            </div>
            <div className="item">
              <p className="bold">Phototherapy</p>
              <p>Germany, UK, Singapore</p>
            </div>
            <div className="item">
              <p className="bold">Aesthetic Laser</p>
              <p>
                USA, Russia, Germany, UK, Italy, France, Turkey, Vienna,
                Singapore, Thailand, Korea, UAE, Pakistan, Malaysia
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="certificates">
        <div className="title">
          <img src={leaf} alt="" />
          <h1>Certificates</h1>
        </div>

        <div className="content">
          <img src={drShamimC1} alt="" className="certificate" />
          <img src={drShamimC2} alt="" className="certificate" />
          <img src={drShamimC3} alt="" className="certificate" />
          <img src={drShamimC4} alt="" className="certificate" />
          <img src={drShamimC5} alt="" className="certificate" />
          <img src={drShamimC6} alt="" className="certificate" />
          <img src={drShamimC7} alt="" className="certificate" />
          <img src={drShamimC8} alt="" className="certificate" />
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default MainDoctor;
